export const getTrades = state => (
    state.impactAnalysis.tradePricedToday.trades
);

export const getOriginalTrades = state => (
    state.impactAnalysis.tradePricedToday.originalTradesSelection
);
